<span 
  *ngIf="integrationType !== 'None'" 
  class="status-pill"
  [ngClass]="pillClass">
  <img 
    *ngIf="showIcon && logoSrc" 
    class="status-icon" 
    [src]="logoSrc" 
    [alt]="logoAlt || 'Integration logo'"
    title="Integration logo">
  {{ status }}
</span>
